<app-video-call-modal
  *ngIf="(callOverlay.getActive$() | async)"
  [incomingCall]="(callOverlay.getPayload$() | async)?.incomingCall"
  [calleeUserId]="(callOverlay.getPayload$() | async)?.calleeUserId"
  [patientId]="(callOverlay.getPayload$() | async)?.patientId"
  [callType]="(callOverlay.getPayload$() | async)?.callType"
  [callContextType]="(callOverlay.getPayload$() | async)?.callContextType"
></app-video-call-modal>

<app-group-call
  *ngIf="(groupOverlay.getActive$() | async)"
  [callId]="(groupOverlay.getPayload$() | async)?.callId ?? ''"
  [roomName]="(groupOverlay.getPayload$() | async)?.roomName ?? ''"
  [token]="(groupOverlay.getPayload$() | async)?.token ?? ''"
  [serverUrl]="(groupOverlay.getPayload$() | async)?.serverUrl ?? ''"
  [title]="(groupOverlay.getPayload$() | async)?.title ?? ''"
  [callType]="(groupOverlay.getPayload$() | async)?.callType ?? 2"
  [skipPermissionCheck]="true"
></app-group-call>

<router-outlet /><app-toast></app-toast>  
<app-loading 
  [isVisible]="(loadingService.isLoading$ | async) ?? false"
  [title]="(loadingService.title$ | async) ?? ''"
  [message]="(loadingService.message$ | async) ?? ''"
  [showProgress]="(loadingService.showProgress$ | async) ?? false"
  [progress]="(loadingService.progress$ | async) ?? 0">
</app-loading>

<div class="palette-backdrop" *ngIf="showPaletteModal">
  <div class="palette-modal">
    <h3 class="palette-title">Choose your color palette</h3>
    <p class="palette-subtitle">You can change this later from settings.</p>

    <div class="palette-grid">
      <button
        type="button"
        class="palette-card"
        *ngFor="let palette of paletteOptions"
        [class.active]="selectedPaletteId === palette.id"
        (click)="selectPalette(palette.id)"
      >
        <span class="palette-swatch" [style.background]="palette.preview"></span>
        <span class="palette-name">{{ palette.name }}</span>
      </button>
    </div>

    <div class="palette-actions">
      <button type="button" class="btn amts-bg-el23 amts-text-white" (click)="confirmPaletteSelection()">
        Continue
      </button>
    </div>
  </div>
</div>
